import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { auth } from '../../firebase';
import { adminApiService } from './adminApiService';
import { secureTokenStorage } from './secureTokenStorage';

export const loginAdmin = async (email, password) => {
  try {
    // First, authenticate with Firebase
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    
    if (userCredential.user) {
      // After successful Firebase login, call the backend API
      const apiResponse = await adminApiService.adminLogin();
      
      if (apiResponse.success) {
        return {
          success: true,
          user: userCredential.user,
          apiUser: apiResponse.user,
          apiToken: apiResponse.token
        };
      } else {
        // If API call fails, still log out from Firebase
        await signOut(auth);
        return {
          success: false,
          error: `API authentication failed: ${apiResponse.error}`
        };
      }
    }
    
    return {
      success: false,
      error: 'Firebase authentication failed'
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

export const logoutAdmin = async () => {
  try {
    // Clear API session data
    adminApiService.clearSession();
    
    // Sign out from Firebase
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

export const getCurrentAdmin = () => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      
      if (user) {
        // If Firebase user exists, get the API user data
        const apiUserData = adminApiService.getCurrentAdminData();
        resolve(apiUserData || user);
      } else {
        resolve(null);
      }
    });
  });
};

export const isAdminAuthenticated = () => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      
      if (user) {
        // Check if both Firebase user exists and API session is valid with security validation
        const hasValidApiSession = adminApiService.hasValidSession();
        
        // Additional security check: verify token hasn't expired
        if (hasValidApiSession) {
          const timeToExpiry = secureTokenStorage.getTokenTimeToExpiry();
          if (timeToExpiry <= 0) {
            // Token has expired, clear session
            adminApiService.clearSession();
            resolve(false);
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      } else {
        // No Firebase user, clear any existing API session
        adminApiService.clearSession();
        resolve(false);
      }
    });
  });
}; 